var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import semver from 'semver';
import get from 'lodash.get';
import { getJson } from '../common';
import { getEntrypoints } from './get-entry-points';
import { getMFESupportsRerendering } from './get-mfe-supports-rerendering';
import { getVersionMismatches } from './get-version-mismatches';
import { isVersionedUrl } from './is-versioned-url';
export function getBundleInfo(mainPackageUrl_1, fallbackPackageUrl_1) {
    return __awaiter(this, arguments, void 0, function* (mainPackageUrl, fallbackPackageUrl, exposedDependencies = {}, signal, retries, onRequestError) {
        var _a;
        const { data: metadata, url: packageUrl } = yield getMetadata({
            fallbackPackageUrl,
            mainPackageUrl,
            onRequestError,
            retries,
            signal,
        });
        const { bundledWith, name, sharedDependencies } = metadata;
        const exactPackageUrl = packageUrl.replace('/dist/metadata.json', '');
        const cache = getCacheSetting(exactPackageUrl);
        let dependencies;
        if (metadata.dependencies) {
            dependencies = metadata.dependencies;
        }
        else {
            const { data: packageJson } = yield getJson(`${exactPackageUrl}/package.json`, {
                cache,
                retries,
                signal,
            });
            dependencies = packageJson.dependencies;
        }
        const mismatch = getVersionMismatches(exposedDependencies, dependencies, sharedDependencies);
        const hasMismatch = !!Object.keys(mismatch).length;
        const startupVersion = bundledWith === null || bundledWith === void 0 ? void 0 : bundledWith['@servicetitan/startup'];
        const supportLightBundles = startupVersion && semver.gte(startupVersion, '17.0.0');
        const embed = !hasMismatch && supportLightBundles;
        const bundleType = embed ? 'light' : 'full';
        const withBaseUrl = (path) => `${exactPackageUrl}/dist/bundle/${bundleType}/${path}`;
        let entrypoints;
        if ((_a = metadata.entrypoints) === null || _a === void 0 ? void 0 : _a[bundleType]) {
            entrypoints = metadata.entrypoints[bundleType];
        }
        else {
            entrypoints = yield getEntrypoints(withBaseUrl('entrypoints.json'), cache);
        }
        const disposer = () => {
            if (embed) {
                const path = Object.values(sharedDependencies).shift();
                if (path) {
                    get(window, path).getStorage().clear(name);
                }
            }
        };
        const urls = Object.entries(entrypoints).reduce((result, [key, value]) => (Object.assign(Object.assign({}, result), { [key]: value.map(withBaseUrl) })), {});
        return {
            disposer,
            mfeSupportsRerendering: getMFESupportsRerendering(bundledWith, dependencies),
            mismatch: hasMismatch ? mismatch : undefined,
            urls,
            WebComponent: name,
        };
    });
}
function getMetadata(props) {
    return __awaiter(this, void 0, void 0, function* () {
        const { fallbackPackageUrl, mainPackageUrl, onRequestError, retries, signal } = props;
        return getJson(`${mainPackageUrl}/dist/metadata.json`, {
            cache: getCacheSetting(mainPackageUrl),
            retries: fallbackPackageUrl ? 0 : retries,
            onRequestError,
            signal,
        }).catch(e => {
            if (!fallbackPackageUrl) {
                throw e;
            }
            return getJson(`${fallbackPackageUrl}/dist/metadata.json`, {
                retries,
                onRequestError,
                cache: getCacheSetting(fallbackPackageUrl),
                signal,
            });
        });
    });
}
function getCacheSetting(url) {
    return isVersionedUrl(url) ? undefined : 'no-store';
}
//# sourceMappingURL=get-bundle-info.js.map